/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lg_Companion_S2Inputs */

const en_lg_companion_s2 = /** @type {(inputs: Lg_Companion_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in to KerjaBareng. Open the full Google Calendar event editor in English or Indonesian, click the extension icon, then choose a workspace and meeting you can access.`)
};

const id_lg_companion_s2 = /** @type {(inputs: Lg_Companion_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masuk ke KerjaBareng. Buka editor lengkap acara Google Calendar berbahasa Indonesia atau Inggris, klik ikon ekstensi, lalu pilih workspace dan rapat yang dapat kamu akses.`)
};

/**
* | output |
* | --- |
* | "Sign in to KerjaBareng. Open the full Google Calendar event editor in English or Indonesian, click the extension icon, then choose a workspace and meeting yo..." |
*
* @param {Lg_Companion_S2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const lg_companion_s2 = /** @type {((inputs?: Lg_Companion_S2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lg_Companion_S2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_lg_companion_s2(inputs)
	return en_lg_companion_s2(inputs)
});